// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"c51924d7","703":"bd1081a3"}[chunkId] + ".chunk.js";
};